import React from 'react';

const Navigation = ({ sections, scrollToSection, unlockedSections }) => {
  return (
    <nav className="fixed top-0 w-full bg-white/90 backdrop-blur-md z-50 shadow-sm">
      <div className="max-w-6xl mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <div className="font-bold text-xl text-gray-800">NTU Appeal</div>
          <div className="hidden md:flex space-x-6">
            {sections.slice(1).map((section) => (
              <button
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                className={`text-gray-600 hover:text-blue-600 transition-colors font-medium flex items-center gap-2 ${
                  unlockedSections.has(section.id) ? '' : 'opacity-50'
                }`}
              >
                <span>{section.icon}</span>
                {section.name}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;